import { dev } from '$app/environment';
import * as Sentry from '@sentry/browser';
import { captureConsoleIntegration, httpClientIntegration } from '@sentry/integrations';

if (!dev) {
    Sentry.init({
        dsn: 'https://d1cfaa6cbabe540d4bcdb5cf9a7f8879@o4506405303746560.ingest.sentry.io/4506405316526080',

        integrations: [
            httpClientIntegration(), // Captures errors on failed requests from Fetch and XHR
            Sentry.browserTracingIntegration(),
            Sentry.browserProfilingIntegration(),
            captureConsoleIntegration({ levels: ['error'] })
        ],

        attachStacktrace: true, // stack traces are automatically attached to all messages logged
        ignoreErrors: [
            'Hydration did not mount',
            'This is an expected result when the User already exists. Push subscription is being transferred the existing User.' // One Signal non-error error... 🙄
        ],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.5,

        // Set profilesSampleRate to 1.0 to profile every transaction.
        // Since profilesSampleRate is relative to tracesSampleRate,
        // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
        // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
        // results in 25% of transactions being profiled (0.5*0.5=0.25)
        profilesSampleRate: 0.5
    });
}

/** @type {import('@sveltejs/kit').HandleClientError} */
export async function handleError({ error, event, status, message }) {
    if (status === 404 && event.url.pathname.includes('/api/auth')) {
        // Client errors when goto/a is to an internal api AND it returns a redirect, ignore api oauth flow as it actually works.
        return;
    }

    // Rethrow
    throw error;
}
